export default component => {
  return {
    name: 'VsSwitch',
    computed: {
      listeners(){
        let listeners = this.$listeners;
        //detect edge browser
        let isIE = !!document.documentMode;
        let isEdge = !isIE && !!window.StyleMedia;
        if(isIE || isEdge){
          listeners.input = () => {};
          listeners.change = () => {this.$emit('input', !this.$children[0].value);};
        }
        return listeners;
      }
    },
    render(h){
      const slots = Object.keys(this.$slots).reduce((arr, key) => arr.concat(this.$slots[key]), []);
      return h(component, {
        attrs: this.$attrs,
        props: component.props,
        on: this.listeners,
      }, slots);
    },
  }
};